<template>
  <div class="live-page">
    <div class="topbar">
      <div class="title">直播预览</div>
      <div class="actions">
        <button class="btn" @click="refresh">刷新</button>
        <button class="btn" @click="openInNewTab">新窗口打开</button>
      </div>
    </div>

    <!-- 加载中提示 -->
    <div v-if="!loaded && !blocked" class="loading">正在加载直播...</div>

    <!-- iframe 直播 -->
    <iframe
      v-show="!blocked"
      class="live-frame"
      :src="liveUrlWithTs"
      frameborder="0"
      allow="autoplay; fullscreen; picture-in-picture"
      @load="onLoad"
      ref="frame"
    ></iframe>

    <!-- 被拦截时的兜底 -->
    <div v-if="blocked" class="blocked">
      该直播页面可能禁止被嵌入。请点击
      <a :href="liveUrl" target="_blank" rel="noopener">这里</a>
      在新窗口中打开。
    </div>
  </div>
</template>

<script>
export default {
  name: 'LivePreview',
  data() {
    return {
      liveUrl:
        'https://open.ys7.com/console/liveScreen/preview.html?screenId=3092&linkSpec=tk.AwMxLjAKbGl2ZVNjcmVlbiA5NGFlZWM2NjI0MDY0N2IyOThlZjhkNWU0Yjg0ODA5NQAAAVGAaJlatyxVZE1tYW5zVng4Z1JwVmFENUZYY2pvRkpDai83L1c5M1BqdUJDVWM3R2FNPR4Q5gWqaYiISYWJRXvJ8oSeUCQBIQJpZCEEMzA5MgAAAAAAAAAA',
      loaded: false,
      blocked: false,
      ts: Date.now(),
      watchdog: null
    };
  },
  computed: {
    liveUrlWithTs() {
      // 加上时间戳避免缓存（不影响原有参数）
      const sep = this.liveUrl.includes('?') ? '&' : '?';
      return `${this.liveUrl}${sep}ts=${this.ts}`;
    }
  },
  mounted() {
    // 若 5 秒还未触发 load，判定可能被拦截（X-Frame-Options/CSP）
    this.watchdog = setTimeout(() => {
      if (!this.loaded) this.blocked = true;
    }, 5000);
  },
  beforeDestroy() {
    if (this.watchdog) clearTimeout(this.watchdog);
  },
  methods: {
    onLoad() {
      this.loaded = true;
      this.blocked = false;
      if (this.watchdog) clearTimeout(this.watchdog);
    },
    refresh() {
      this.loaded = false;
      this.blocked = false;
      this.ts = Date.now(); // 变更 src 触发重载
    },
    openInNewTab() {
      window.open(this.liveUrl, '_blank');
    }
  }
};
</script>

<style scoped>
.live-page {
  display: flex;
  flex-direction: column;
  height: 100vh;
  background: #0b1220;
  color: #fff;
  overflow: hidden;
}

.topbar {
  height: 54px;
  padding: 0 14px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #111a2c;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.title {
  font-size: 16px;
  font-weight: 600;
}

.actions .btn {
  margin-left: 10px;
  padding: 6px 12px;
  background: #1f6feb;
  color: #fff;
  border: none;
  border-radius: 8px;
  cursor: pointer;
}
.actions .btn:hover { opacity: 0.9; }

.live-frame {
  flex: 1;
  width: 100%;
  border: 0;
  background: #000;
}

.loading,
.blocked {
  position: absolute;
  top: 54px;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  color: #c9d1d9;
  pointer-events: none;
}
.blocked {
  pointer-events: auto;
}
.blocked a {
  color: #58a6ff;
  text-decoration: underline;
}
</style>
